<template>
  <div class="row raffle-campaigns-report">
    <div class="col-xl-12 col-md-12 col-xs-12">
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <div class="table-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; flex-wrap: wrap;">
            <div class="left-group" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; flex: 1 1 auto;">
              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <label>{{ $t('raffleCampaigns.id') }}</label>
                <el-input
                  v-model="idFilter"
                  :placeholder="$t('raffleCampaigns.id')"
                  size="small"
                  clearable
                  @keyup.enter.native="applyFilters"
                />
              </div>

              <div class="form-group" style="flex: 1 1 180px; margin: 0;">
                <label>{{ $t('raffleCampaigns.name') }}</label>
                <el-input
                  v-model="nameFilter"
                  :placeholder="$t('raffleCampaigns.search')"
                  size="small"
                  clearable
                  @keyup.enter.native="applyFilters"
                />
              </div>

              <div class="form-group" style="flex: 0 0 140px; margin: 0;">
                <label>{{ $t('raffleCampaigns.active') }}</label>
                <el-select
                  v-model="statusFilter"
                  clearable
                  size="small"
                  :placeholder="$t('general.select')"
                  style="width: 100%;"
                >
                  <el-option :label="$t('general.active')" :value="1" />
                  <el-option :label="$t('general.inactive')" :value="0" />
                </el-select>
              </div>

              <div class="form-group" style="flex: 0 0 160px; margin: 0;">
                <label>{{ $t('raffleCampaigns.type') }}</label>
                <el-select
                  v-model="typeFilter"
                  clearable
                  size="small"
                  :placeholder="$t('general.select')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="option in typeOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </div>

              <div class="form-group" style="flex: 0 0 240px; margin: 0;">
                <label>{{ $t('raffleCampaigns.startEnd') }}</label>
                <el-date-picker
                  type="daterange"
                  v-model="dateRangeFilter"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  size="small"
                  :placeholder="$t('raffleCampaigns.startEnd')"
                  style="width: 100%;"
                />
              </div>

              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <button class="btn add" @click="applyFilters" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>
            </div>
          </div>

          <div class="data-table raffle-campaigns-report__table-wrap" style="margin-top: 20px;">
            <el-table
              :data="tableData"
              :empty-text="$t('gestiune.noData')"
              style="width: 100%;"
            >
              <el-table-column prop="id" :label="$t('raffleCampaigns.id')" width="80" />
              <el-table-column prop="name" :label="$t('raffleCampaigns.name')" min-width="160" show-overflow-tooltip />
              <el-table-column :label="$t('raffleCampaigns.type')" min-width="110">
                <template slot-scope="props">
                  {{ typeLabel(props.row.type) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('raffleCampaigns.startEnd')" min-width="180">
                <template slot-scope="props">
                  {{ formatDate(props.row.starts_at) }} - {{ formatDate(props.row.ends_at) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('orders.status')" width="100">
                <template slot-scope="props">
                  {{ props.row.active ? $t('general.active') : $t('general.inactive') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('raffleCampaigns.usersJoined')" width="120">
                <template slot-scope="props">
                  {{ props.row.users_joined != null ? props.row.users_joined : 0 }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('raffleCampaigns.ordersCount')" width="120">
                <template slot-scope="props">
                  {{ props.row.orders_count != null ? props.row.orders_count : 0 }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('raffleCampaigns.ordersTotal')" width="130">
                <template slot-scope="props">
                  {{ formatMoney(props.row.orders_total) }} {{ currency }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('general.actions')" min-width="220">
                <template slot-scope="scope">
                  <div class="raffle-campaigns-report__actions">
                    <button
                      class="btn add raffle-campaigns-report__action"
                      @click.stop="goToParticipants(scope.row)"
                      :title="$t('raffleCampaigns.participants')"
                    >
                      {{ $t('raffleCampaigns.participants') }}
                    </button>
                    <button
                      class="btn add raffle-campaigns-report__action"
                      @click.stop="exportEntries(scope.row)"
                      :disabled="exportingId === scope.row.id"
                      :title="$t('raffleCampaigns.exportEntries')"
                    >
                      {{ $t('raffleCampaigns.exportEntries') }}
                    </button>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div class="raffle-campaigns-report__pagination">
              <el-pagination
                layout="prev, pager, next"
                :total="paginationDef.totalRecords"
                :page-size="paginationDef.perPage"
                :current-page.sync="paginationDef.page"
                @current-change="handlePageChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Select, Option, DatePicker, Pagination } from 'element-ui'
import swal from 'sweetalert2'

Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Pagination)

export default {
  props: {
    isRaffleCampaignsReport: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      exportingId: null,
      idFilter: '',
      nameFilter: '',
      statusFilter: null,
      typeFilter: null,
      dateRangeFilter: [],
      tableData: [],
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      paginationDef: {
        page: 1,
        perPage: 25,
        totalRecords: 0
      }
    }
  },
  computed: {
    typeOptions () {
      return [
        { value: 'order_count', label: this.$t('raffleCampaigns.typeOrderCount') },
        { value: 'order_total', label: this.$t('raffleCampaigns.typeOrderTotal') }
      ]
    }
  },
  watch: {
    isRaffleCampaignsReport (active) {
      if (active) {
        this.getCampaigns()
      }
    }
  },
  created () {
    this.getCampaigns()
    this.$bus.$on('refreshRaffleCampaignsReport', this.getCampaigns)
  },
  beforeDestroy () {
    this.$bus.$off('refreshRaffleCampaignsReport', this.getCampaigns)
  },
  methods: {
    typeLabel (type) {
      if (type === 'order_total') {
        return this.$t('raffleCampaigns.typeOrderTotal')
      }
      return this.$t('raffleCampaigns.typeOrderCount')
    },
    formatMoney (value) {
      const n = parseFloat(value || 0)
      return isNaN(n) ? '0.00' : n.toFixed(2)
    },
    applyFilters () {
      this.paginationDef.page = 1
      this.getCampaigns()
    },
    handlePageChange (page) {
      this.paginationDef.page = page
      this.getCampaigns()
    },
    normalizeActiveFilterValue (value) {
      if (value === true || value === 1 || value === '1') return true
      if (value === false || value === 0 || value === '0') return false
      return null
    },
    buildParams () {
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        per_page: this.paginationDef.perPage
      }
      const id = String(this.idFilter || '').trim()
      if (id !== '') {
        params.id = id
      }
      const name = String(this.nameFilter || '').trim()
      if (name !== '') {
        params.name = name
      }
      const active = this.normalizeActiveFilterValue(this.statusFilter)
      if (active !== null) {
        params.active = active
      }
      if (this.typeFilter) {
        params.type = this.typeFilter
      }
      if (this.dateRangeFilter && this.dateRangeFilter.length === 2 && this.dateRangeFilter[0] && this.dateRangeFilter[1]) {
        params.start_date = this.dateRangeFilter[0]
        params.end_date = this.dateRangeFilter[1]
      }
      return params
    },
    normalizeListResponse (response) {
      const payload = response.data || {}
      if (payload.pagination) {
        return {
          rows: payload.data || [],
          page: payload.pagination.page || this.paginationDef.page,
          perPage: payload.pagination.per_page || payload.pagination.perPage || this.paginationDef.perPage,
          total: payload.pagination.total || payload.pagination.totalRecords || 0
        }
      }
      if (response.pagination) {
        return {
          rows: Array.isArray(payload) ? payload : (payload.data || []),
          page: response.pagination.page || this.paginationDef.page,
          perPage: response.pagination.per_page || response.pagination.perPage || this.paginationDef.perPage,
          total: response.pagination.total || response.pagination.totalRecords || 0
        }
      }
      if (Array.isArray(payload)) {
        return { rows: payload, page: 1, perPage: this.paginationDef.perPage, total: payload.length }
      }
      if (Array.isArray(payload.data)) {
        return { rows: payload.data, page: 1, perPage: this.paginationDef.perPage, total: payload.data.length }
      }
      return { rows: [], page: 1, perPage: this.paginationDef.perPage, total: 0 }
    },
    getCampaigns () {
      this.loading = true
      this.apiRequest('/reports/raffle-campaigns', 'GET', this.buildParams(), (response) => {
        if (response.status === true) {
          const normalized = this.normalizeListResponse(response)
          this.tableData = (normalized.rows || []).map(row => ({
            ...row,
            active: !!(parseInt(row.active) === 1 || row.active === true)
          }))
          this.paginationDef.page = normalized.page
          this.paginationDef.perPage = normalized.perPage
          this.paginationDef.totalRecords = normalized.total
        } else {
          this.tableData = []
          this.paginationDef.totalRecords = 0
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    goToParticipants (row) {
      if (!row || row.id == null) return
      this.$router.push({
        name: 'Raffle Campaign Participants Report',
        params: { campaignId: String(row.id) },
        query: {
          tab: 'raffle-campaigns-report',
          title: row.name || String(row.id)
        }
      })
    },
    exportEntries (row) {
      if (!row || row.id == null || this.exportingId != null) return
      this.exportingId = row.id
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/raffle-campaigns/' + row.id + '/export-entries', 'GET', data, (response) => {
        this.exportingId = null
        if (response.status === true && response.data && response.data.file) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name || ('raffle-campaign-' + row.id + '-entries.txt'))
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped>
.raffle-campaigns-report .form-group {
  margin-bottom: 15px;
}
.raffle-campaigns-report__table-wrap {
  overflow-x: auto;
}
.raffle-campaigns-report__pagination {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.raffle-campaigns-report__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.raffle-campaigns-report__action {
  font-size: 11px;
  padding: 3px 6px;
  margin: 0;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/RaffleCampaignsReport.vue